import React from 'react';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import { actions } from '../../services/userProfile';

const styled = withStyles(theme => {
  return {
    container: {
      overflowX: 'auto'
    },
    table: {
      margin: '0px auto'
    },
    loadingContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    timeAgo: {
      whiteSpace: 'nowrap'
    },
    tableHead: {
      backgroundColor: '#fff',
    }
  };
});

class TabTokens extends React.Component {
  componentDidMount() {
    const { data } = this.props;
    if (data.tokens) {
      return;
    }
    this.props.actions.load();
  }

  renderRow(data) {
    const { classes } = this.props;

    return (
      <TableRow key={data._id}>
        <TableCell padding="dense">
          <Typography>{data.status}</Typography>
        </TableCell>
        <TableCell padding="dense">
          <Typography className={classes.timeAgo}>
            {moment(data.createTime).fromNow()}
          </Typography>
        </TableCell>
        <TableCell padding="dense">
          <Typography>{data.deviceMaker}</Typography>
        </TableCell>
        <TableCell padding="dense">
          <Typography>{data.deviceModel}</Typography>
        </TableCell>
        <TableCell padding="dense">
          <Typography>{data.appVersion}</Typography>
        </TableCell>
        <TableCell padding="dense">
          <Typography>{data.platform}</Typography>
        </TableCell>
        <TableCell padding="dense">
          <Typography>{data.platformVersion}</Typography>
        </TableCell>
        <TableCell padding="dense">
          <Typography>{data.accessLevel}</Typography>
        </TableCell>
      </TableRow>
    );
  }

  render() {
    const { data, classes } = this.props;
    if (!data.tokens) {
      return (
        <div className={classes.loadingContainer}>
          <CircularProgress />
        </div>
      );
    }

    return (
      <div className={classes.container}>
        <Table className={classes.table}>
          <TableHead className={classes.tableHead}>
            <TableRow>
              <TableCell>Status</TableCell>
              <TableCell>Created</TableCell>
              <TableCell>Device Maker</TableCell>
              <TableCell>Device Model</TableCell>
              <TableCell>App Version</TableCell>
              <TableCell>Platform</TableCell>
              <TableCell>Platform Version</TableCell>
              <TableCell>Level</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{data.tokens.map(item => this.renderRow(item))}</TableBody>
        </Table>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state.userProfile.data
  };
};

const mapDispatchToProps = dispatch => ({
  actions: {
    load: () => dispatch(actions.loadTokens())
  }
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(styled(TabTokens))
);
